import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type { NoSearchResultEvent } from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const NO_SEARCH_RESULT_EVENT = 'no_search_result'

export const triggerNoSearchResultEvent = (event: NoSearchResultEvent) =>
  triggerEvent(NO_SEARCH_RESULT_EVENT, event)

export const onNoSearchResultEvent = (
  callback: EventCallback<NoSearchResultEvent>
) => subscribeEvent(NO_SEARCH_RESULT_EVENT, callback)

export const removeNoSearchResultEvent = (
  token: EventToken<NoSearchResultEvent>
) => unsubscribeEvent(NO_SEARCH_RESULT_EVENT, token)
